const initialState = {
    advocateDetails: {}
  };
  
  const advocateDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'ADVOCATEDETAILS':
        if(!action.payload) {
          return initialState
        }
        else{
          return{
            ...state,
            advocateDetails : action.payload
          }
        }
      default:
        return state;
    }
  };
  
  export default advocateDetailsReducer;